import { colors } from '@chegg-ui/theme'
import { IconButton } from '@chegg-ui/button'
import { EDITOR_TOOLBAR_TEST_ID } from '@chegg-wt/core-wa/constants/paraphraser'
import history from '@chegg-wt/core-wa/utils/history/history'
import { isWindowDefined } from '@chegg-wt/core/utils/isWindowDefined'
import { useEffect } from 'react'
import { Tooltip } from '@chegg-ui/tooltip'
import {
  redoEnabledSelector,
  undoEnabledSelector,
} from '@chegg-wt/core-wa/state/selectors'
import { useSelector } from 'react-redux'
import { UndoIcon } from '../icons/UndoIcon'
import { ButtonTooltip, ToolbarContainer } from './styled'
import { TOOLS } from './constants'
import { keyboardEventHandler } from './keyboardEventHandler'

export const EditorMainToolbar = () => {
  const isUndoEnabled = useSelector(undoEnabledSelector)
  const isRedoEnabled = useSelector(redoEnabledSelector)
  useEffect(() => {
    const onKeyDownHandler = (event) => keyboardEventHandler(event)
    if (isWindowDefined) {
      document.addEventListener('keydown', onKeyDownHandler)
    }

    return () => {
      document.removeEventListener('keydown', onKeyDownHandler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ToolbarContainer data-test={`${EDITOR_TOOLBAR_TEST_ID}`}>
      <Tooltip
        position="top"
        targetElement={
          <IconButton
            screenReaderOnlyText={TOOLS.UNDO}
            onClick={() => history.applyUndo()}
            size="xsmall"
            disabled={!isUndoEnabled}
          >
            <UndoIcon
              color={isUndoEnabled ? colors.grey800 : colors.grey300}
              size="xsmall"
            />
          </IconButton>
        }
      >
        <ButtonTooltip>{TOOLS.UNDO}</ButtonTooltip>
      </Tooltip>

      <Tooltip
        position="top"
        targetElement={
          <IconButton
            screenReaderOnlyText={TOOLS.REDO}
            onClick={() => history.applyRedo()}
            size="xsmall"
            disabled={!isRedoEnabled}
          >
            <UndoIcon
              color={isRedoEnabled ? colors.grey800 : colors.grey300}
              isFlipped
              size="xsmall"
            />
          </IconButton>
        }
      >
        <ButtonTooltip>{TOOLS.REDO}</ButtonTooltip>
      </Tooltip>
    </ToolbarContainer>
  )
}
